import script from "./BettingPickActionButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BettingPickActionButton.vue?vue&type=script&setup=true&lang=ts"

import "./BettingPickActionButton.vue?vue&type=style&index=0&id=3e6dfe9a&scoped=true&lang=css"
import "./BettingPickActionButton.vue?vue&type=style&index=1&id=3e6dfe9a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e6dfe9a"]])

export default __exports__